import onReady from '../utils/onReady';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class TextBlockColsExpand {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    attachEventListeners() {
        if(this.dom.read_more_btns) {
            this.dom.read_more_btns.forEach((btn) => {
                // Do whatever you want with the node object.
                let parentTextNode = btn.parentNode.parentNode.querySelector(".text"); 
                btn.addEventListener("click", () =>  {
                    if(parentTextNode.classList.contains("open")) {
                        btn.innerHTML = "+";
                        this.hideFullTextBlock(parentTextNode)
                    } else {
                        btn.innerHTML = "-";
                        this.showFullTextBlock(parentTextNode);
                    }
                    
                });
            });
        }
    }

    showFullTextBlock(element) {
        element.classList.add("open");
    }

    hideFullTextBlock(element) {
        element.classList.remove("open");
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container,
            read_more_btns: container.querySelectorAll(".expand"),
        };

        this.attachEventListeners();


    }

}


export default TextBlockColsExpand;